import { Button as AriaButton } from 'react-aria-components';

import { useAriaKeyShortcuts } from '../../shortcuts.ts';
import { Kbd } from '../Kbd/Kbd.tsx';
import styles from './SearchTrigger.module.css';

export interface SearchTriggerProps {
  /** What it searches, e.g. "Search patients". Also the accessible name. */
  label: string;
  /** Shown instead of `label` on phones, e.g. "Search". */
  shortLabel?: string;
  /** The `useShortcut` combo that also opens the search, e.g. "mod+k". */
  shortcut: string;
  onPress: () => void;
}

/**
 * The top-bar button that opens a search palette. It looks like a search field, not a
 * button, so it doesn't compete with a page's own actions, and it shows its shortcut.
 */
export function SearchTrigger({ label, shortLabel, shortcut, onPress }: SearchTriggerProps) {
  const shortcutRef = useAriaKeyShortcuts(shortcut);
  return (
    <AriaButton ref={shortcutRef} className={styles.trigger} aria-label={label} onPress={onPress}>
      <span className={styles.lens} aria-hidden="true" />
      <span className={styles.label} data-has-short={shortLabel === undefined ? undefined : true}>
        {label}
      </span>
      {shortLabel === undefined ? null : <span className={styles.shortLabel}>{shortLabel}</span>}
      <span className={styles.keys} aria-hidden="true">
        <Kbd combo={shortcut} />
      </span>
    </AriaButton>
  );
}
